import(/* webpackMode: "eager" */ "/vercel/path0/web/web/src/app/about/page.tsx");
